import { Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { LOBBY_CONFIG_REPOSITORY_TOKEN, ILobbyConfig } from "./interfaces";
import { IRepository, IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";

@Injectable()
export class GetConfigUseCase implements IUseCase<void, Promise<ILobbyConfig|undefined>>{

    constructor(
        @Inject(LOBBY_CONFIG_REPOSITORY_TOKEN) private configRepository: IRepository<ILobbyConfig|undefined>
    ) {
    }

    async execute(): Promise<ILobbyConfig|undefined> {
        return firstValueFrom(this.configRepository.get());
    }
}
